module.exports = __webpack_public_path__ + "img/c47.ca13356e.png";